export const locales = [
  {
    label: 'English (Australia)',
    locale: 'en-AU',
    language: 'English',
    flag: '🇦🇺'
  },
  {
    label: 'English (United States)',
    locale: 'en-US',
    language: 'English',
    flag: '🇺🇸'
  },
  {
    label: 'English (United Kingdom)',
    locale: 'en-GB',
    language: 'English',
    flag: '🇬🇧'
  },
  {
    label: 'English (Canada)',
    locale: 'en-CA',
    language: 'English',
    flag: '🇨🇦'
  },
  {
    label: 'English (New Zealand)',
    locale: 'en-NZ',
    language: 'English',
    flag: '🇳🇿'
  },
  {
    label: 'English (India)',
    locale: 'en-IN',
    language: 'English',
    flag: '🇮🇳'
  },

  {
    label: 'Spanish (Spain)',
    locale: 'es-ES',
    language: 'Spanish',
    flag: '🇪🇸'
  },
  {
    label: 'Spanish (Mexico)',
    locale: 'es-MX',
    language: 'Spanish',
    flag: '🇲🇽'
  },
  {
    label: 'Spanish (Argentina)',
    locale: 'es-AR',
    language: 'Spanish',
    flag: '🇦🇷'
  },
  {
    label: 'Spanish (Colombia)',
    locale: 'es-CO',
    language: 'Spanish',
    flag: '🇨🇴'
  },
  {
    label: 'Spanish (Chile)',
    locale: 'es-CL',
    language: 'Spanish',
    flag: '🇨🇱'
  },
  { label: 'Spanish (Peru)', locale: 'es-PE', language: 'Spanish', flag: '🇵🇪' },
  {
    label: 'Spanish (United States)',
    locale: 'es-US',
    language: 'Spanish',
    flag: '🇺🇸'
  },

  { label: 'French (France)', locale: 'fr-FR', language: 'French', flag: '🇫🇷' },
  { label: 'French (Canada)', locale: 'fr-CA', language: 'French', flag: '🇨🇦' },
  {
    label: 'French (Belgium)',
    locale: 'fr-BE',
    language: 'French',
    flag: '🇧🇪'
  },
  {
    label: 'French (Switzerland)',
    locale: 'fr-CH',
    language: 'French',
    flag: '🇨🇭'
  },

  {
    label: 'German (Germany)',
    locale: 'de-DE',
    language: 'German',
    flag: '🇩🇪'
  },
  {
    label: 'German (Austria)',
    locale: 'de-AT',
    language: 'German',
    flag: '🇦🇹'
  },
  {
    label: 'German (Switzerland)',
    locale: 'de-CH',
    language: 'German',
    flag: '🇨🇭'
  },

  {
    label: 'Portuguese (Portugal)',
    locale: 'pt-PT',
    language: 'Portuguese',
    flag: '🇵🇹'
  },
  {
    label: 'Portuguese (Brazil)',
    locale: 'pt-BR',
    language: 'Portuguese',
    flag: '🇧🇷'
  },

  {
    label: 'Italian (Italy)',
    locale: 'it-IT',
    language: 'Italian',
    flag: '🇮🇹'
  },
  {
    label: 'Dutch (Netherlands)',
    locale: 'nl-NL',
    language: 'Dutch',
    flag: '🇳🇱'
  },
  { label: 'Dutch (Belgium)', locale: 'nl-BE', language: 'Dutch', flag: '🇧🇪' },

  { label: 'Polish', locale: 'pl-PL', language: 'Polish', flag: '🇵🇱' },
  { label: 'Czech', locale: 'cs-CZ', language: 'Czech', flag: '🇨🇿' },
  { label: 'Slovak', locale: 'sk-SK', language: 'Slovak', flag: '🇸🇰' },
  { label: 'Hungarian', locale: 'hu-HU', language: 'Hungarian', flag: '🇭🇺' },
  { label: 'Romanian', locale: 'ro-RO', language: 'Romanian', flag: '🇷🇴' },
  { label: 'Bulgarian', locale: 'bg-BG', language: 'Bulgarian', flag: '🇧🇬' },
  { label: 'Croatian', locale: 'hr-HR', language: 'Croatian', flag: '🇭🇷' },
  { label: 'Serbian', locale: 'sr-RS', language: 'Serbian', flag: '🇷🇸' },
  { label: 'Slovenian', locale: 'sl-SI', language: 'Slovenian', flag: '🇸🇮' },
  { label: 'Lithuanian', locale: 'lt-LT', language: 'Lithuanian', flag: '🇱🇹' },
  { label: 'Latvian', locale: 'lv-LV', language: 'Latvian', flag: '🇱🇻' },
  { label: 'Estonian', locale: 'et-EE', language: 'Estonian', flag: '🇪🇪' },

  { label: 'Swedish', locale: 'sv-SE', language: 'Swedish', flag: '🇸🇪' },
  {
    label: 'Norwegian (Bokmål)',
    locale: 'nb-NO',
    language: 'Norwegian',
    flag: '🇳🇴'
  },
  {
    label: 'Norwegian (Nynorsk)',
    locale: 'nn-NO',
    language: 'Norwegian',
    flag: '🇳🇴'
  },
  { label: 'Danish', locale: 'da-DK', language: 'Danish', flag: '🇩🇰' },
  { label: 'Finnish', locale: 'fi-FI', language: 'Finnish', flag: '🇫🇮' },
  { label: 'Icelandic', locale: 'is-IS', language: 'Icelandic', flag: '🇮🇸' },
  { label: 'Irish', locale: 'ga-IE', language: 'Irish', flag: '🇮🇪' },
  { label: 'Welsh', locale: 'cy-GB', language: 'Welsh', flag: '🇬🇧' },
  { label: 'Catalan', locale: 'ca-ES', language: 'Catalan', flag: '🇪🇸' },
  { label: 'Basque', locale: 'eu-ES', language: 'Basque', flag: '🇪🇸' },
  { label: 'Galician', locale: 'gl-ES', language: 'Galician', flag: '🇪🇸' },
  { label: 'Maltese', locale: 'mt-MT', language: 'Maltese', flag: '🇲🇹' },

  {
    label: 'Chinese (Simplified, China)',
    locale: 'zh-CN',
    language: 'Chinese',
    flag: '🇨🇳'
  },
  {
    label: 'Chinese (Traditional, Taiwan)',
    locale: 'zh-TW',
    language: 'Chinese',
    flag: '🇹🇼'
  },
  {
    label: 'Chinese (Hong Kong)',
    locale: 'zh-HK',
    language: 'Chinese',
    flag: '🇭🇰'
  },

  { label: 'Japanese', locale: 'ja-JP', language: 'Japanese', flag: '🇯🇵' },
  { label: 'Korean', locale: 'ko-KR', language: 'Korean', flag: '🇰🇷' },
  { label: 'Thai', locale: 'th-TH', language: 'Thai', flag: '🇹🇭' },
  { label: 'Vietnamese', locale: 'vi-VN', language: 'Vietnamese', flag: '🇻🇳' },
  { label: 'Indonesian', locale: 'id-ID', language: 'Indonesian', flag: '🇮🇩' },
  { label: 'Malay', locale: 'ms-MY', language: 'Malay', flag: '🇲🇾' },
  {
    label: 'Filipino (Tagalog)',
    locale: 'fil-PH',
    language: 'Filipino',
    flag: '🇵🇭'
  },

  { label: 'Hindi', locale: 'hi-IN', language: 'Hindi', flag: '🇮🇳' },
  { label: 'Bengali', locale: 'bn-IN', language: 'Bengali', flag: '🇮🇳' },
  { label: 'Tamil', locale: 'ta-IN', language: 'Tamil', flag: '🇮🇳' },
  { label: 'Telugu', locale: 'te-IN', language: 'Telugu', flag: '🇮🇳' },
  { label: 'Marathi', locale: 'mr-IN', language: 'Marathi', flag: '🇮🇳' },
  { label: 'Gujarati', locale: 'gu-IN', language: 'Gujarati', flag: '🇮🇳' },
  { label: 'Kannada', locale: 'kn-IN', language: 'Kannada', flag: '🇮🇳' },
  { label: 'Malayalam', locale: 'ml-IN', language: 'Malayalam', flag: '🇮🇳' },
  { label: 'Punjabi', locale: 'pa-IN', language: 'Punjabi', flag: '🇮🇳' },
  { label: 'Urdu', locale: 'ur-PK', language: 'Urdu', flag: '🇵🇰' },

  {
    label: 'Arabic (Saudi Arabia)',
    locale: 'ar-SA',
    language: 'Arabic',
    flag: '🇸🇦'
  },
  { label: 'Arabic (UAE)', locale: 'ar-AE', language: 'Arabic', flag: '🇦🇪' },
  { label: 'Arabic (Egypt)', locale: 'ar-EG', language: 'Arabic', flag: '🇪🇬' },
  {
    label: 'Arabic (Morocco)',
    locale: 'ar-MA',
    language: 'Arabic',
    flag: '🇲🇦'
  },
  { label: 'Arabic (Qatar)', locale: 'ar-QA', language: 'Arabic', flag: '🇶🇦' },

  { label: 'Hebrew', locale: 'he-IL', language: 'Hebrew', flag: '🇮🇱' },
  {
    label: 'Persian (Farsi)',
    locale: 'fa-IR',
    language: 'Persian',
    flag: '🇮🇷'
  },
  { label: 'Turkish', locale: 'tr-TR', language: 'Turkish', flag: '🇹🇷' },
  {
    label: 'Azerbaijani',
    locale: 'az-AZ',
    language: 'Azerbaijani',
    flag: '🇦🇿'
  },
  { label: 'Georgian', locale: 'ka-GE', language: 'Georgian', flag: '🇬🇪' },
  { label: 'Armenian', locale: 'hy-AM', language: 'Armenian', flag: '🇦🇲' },

  { label: 'Swahili', locale: 'sw-KE', language: 'Swahili', flag: '🇰🇪' },
  { label: 'Amharic', locale: 'am-ET', language: 'Amharic', flag: '🇪🇹' },
  { label: 'Yoruba', locale: 'yo-NG', language: 'Yoruba', flag: '🇳🇬' },
  { label: 'Igbo', locale: 'ig-NG', language: 'Igbo', flag: '🇳🇬' },
  { label: 'Hausa', locale: 'ha-NG', language: 'Hausa', flag: '🇳🇬' },
  { label: 'Zulu', locale: 'zu-ZA', language: 'Zulu', flag: '🇿🇦' },
  { label: 'Xhosa', locale: 'xh-ZA', language: 'Xhosa', flag: '🇿🇦' },
  { label: 'Afrikaans', locale: 'af-ZA', language: 'Afrikaans', flag: '🇿🇦' }
];
